export enum companiesTypes {
  FETCH_COMPANIES_REQUEST = "FETCH_COMPANIES_REQUEST",
  FETCH_COMPANIES_SUCCESS = "FETCH_COMPANIES_SUCCESS",
  FETCH_COMPANIES_FAILURE = "FETCH_COMPANIES_FAILURE",
}